module.exports = __webpack_public_path__ + "public/1.0.1_200686/img/员工关怀.3e4fd0ad.png";